// ═══════════════════════════════════════════════════════════════════════════════
// Pairing-scoped GCS image stream API paths (re-export from shared)
// ═══════════════════════════════════════════════════════════════════════════════

import {
  buildPairingScopedImageApiPath,
  isPairingScopedImageApiPath,
} from '@fdh/shared';

export {
  buildPairingScopedImageApiPath,
  extractPairingScopedImageFileName,
  isGcsCanonicalHttpsUrl,
  isPairingScopedImageApiPath,
} from '@fdh/shared';

/** Display stream path for a canonical GCS URL; falls back to input when not GCS. */
export const resolvePairingScopedImageDisplayPath = (src: string): string => {
  const trimmed = src.trim();
  if (trimmed === '') return '';
  if (isPairingScopedImageApiPath(trimmed)) {
    return trimmed;
  }
  return buildPairingScopedImageApiPath(trimmed) ?? trimmed;
};
